<script setup lang="ts">
import { formatDate, formatTime } from '~/utils/helpers'
import { formatCurrency } from '~/utils/formatters'
import type { RecentDonation } from '#shared/types/donations'

interface RecentDonationProps {
  recentDonations: RecentDonation[]
}

const props = defineProps<RecentDonationProps>()

const { t } = useI18n('components.templates.donation.recent-donations')
</script>

<template>
  <div class="w-full">
    <span class="pb-3! text-2xl font-bold">
      {{ t('.title') }}
    </span>
    <UMarquee
      pause-on-hover
      :overlay="false"
      :ui="{ root: '[--duration:120s]', content: 'w-auto' }"
    >
      <div
        v-for="(item, itemIndex) in recentDonations"
        :key="`recent-donation-${itemIndex}`"
        class="flex! h-full max-h-120 min-h-40 grow flex-col justify-evenly px-3!"
      >
        <p class="title mb-0! text-5xl">
          {{ formatCurrency(item.amount) }}
        </p>
        <p v-if="item.comments">
          {{ item.comments }}
        </p>
        <p class="font-bold">
          {{
            t('.information', {
              name:
                item.isAnonymous || !item.firstname || !item.lastname
                  ? t('.anonymous')
                  : `${item.firstname} ${item.lastname}`,
              date: formatDate(item.createdAt),
              time: formatTime(item.createdAt)
            })
          }}
        </p>
      </div>
    </UMarquee>
  </div>
</template>

<style scoped></style>
